/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import loadingConfig from '../config/loading.config.json';
import { VApplication } from '../../../application';
import fieldsConfig from '../config/formFields.config.json';
import imageFeatureConfig from '../config/imageFeatureSection.config.json';

export interface IStaticPageContentMethods extends IPluginMethodMap {
  getStaticPageContentSync(args: any): any;
}

export class StaticPageContentService implements IAgentPlugin {
  readonly methods: IStaticPageContentMethods;

  constructor() {
    this.methods = {
      getStaticPageContentSync: this.getProps.bind(this),
    };
  }

  getProps(args: any) {
    return {
      loading: loadingConfig,
      FIELDS: fieldsConfig?.FIELDS,
      LAYOUT: fieldsConfig?.layout,
      backgroundImage: imageFeatureConfig?.backgroundImage,
      illustation: imageFeatureConfig?.illustation,
    };
  }
}
